export enum SegmentEvents {
    survey_subscribed = 'survey_subscribed'
}
